import { render, staticRenderFns } from "./CreateCertificateReanalysisRequestButton.vue?vue&type=template&id=01310084&scoped=true&"
import script from "./CreateCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"
export * from "./CreateCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01310084",
  null
  
)

export default component.exports